export { MiniState } from './state.class';
export { MiniStore } from './store.class';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/mini-ngrx/index.js
// module id = 545
// module chunks = 10